import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Style from './Style.module.css';
import Header from '../../../Components/AdminComponents/Header/Header';
import Sidebar from '../../../Components/AdminComponents/Sidebar/Sidebar';
import DataTable from '../../../Components/AdminComponents/DataTable/DataTable';
import adminInstance from '../../../instance/AdminInstance';

const ReportList = () => {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);

  const columns = [
    {
      name: 'Reason',
      selector: (row) => row.reason,
      sortable: true,
    },
    {
      name: 'Reported Product',
      cell: (row) => (
        <div className={Style.optionsContainer}>
          <button className={Style.viewButton} onClick={() => navigate(`/admin/products/singles/${row.productId._id}`)}>View</button>
          <button className={Style.deleteButton} onClick={() => handleDelete(row.productId._id)}>Block</button>
        </div>
      ),
      width: '300px'
    },
    {
      name: 'ProductOwnerDetails',
      cell: (row) => (
        <div className={Style.optionsContainer}>
          <button className={Style.viewButton} onClick={() => navigate(`/admin/users/singles/${row.productOwnerId._id}`)}>View</button>
          <button className={Style.deleteButton} onClick={() => handleDelete(row.productOwnerId._id)}>Block</button>
        </div>
      ),
      width: '300px'
    },
  ];

  const loadUsers = () => {
    adminInstance.get("/api/super_admin/report/report_product")
      .then((response) => {
        setReports(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleDelete = (itemId) => {
    adminInstance.delete(`/api/super_admin/user_control/deleteProfile/${itemId}`)
      .then(() => loadUsers())
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    loadUsers();
  }, []);

  return (
    <div className={Style.list}>
      <Sidebar />
      <div className={Style.listContainer}>
        <Header />
        <DataTable Row={reports} Columns={columns} ActionColumn="" Title="Reports" Path="reports" />
      </div>
    </div>
  );
};

export default ReportList;
